import { Stack } from '@mui/material';

import { styled } from '@/theme/styled';

const Container = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  flex: 1,
  justifyContent: 'flex-end',
}));

export { Container };
